import { memo, useContext, useState } from "react";
import { ObjectContext } from "@providers/ObjectProvider";
import Avatar from '@mui/joy/Avatar';
import Chip from '@mui/joy/Chip';
import Box from '@mui/joy/Box';
import Button from '@mui/joy/Button';
import ButtonGroup from '@mui/joy/ButtonGroup';
import Card from '@mui/joy/Card';
import CardContent from '@mui/joy/CardContent';
import CardOverflow from '@mui/joy/CardOverflow';
import CardActions from '@mui/joy/CardActions';
import IconButton from '@mui/joy/IconButton';
import Typography from '@mui/joy/Typography';
import SvgIcon from '@mui/joy/SvgIcon';
import SettingsRoundedIcon from '@mui/icons-material/SettingsRounded';
import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded';
import Tooltip from '@mui/joy/Tooltip';
import Table from '@mui/joy/Table';
import Stack from '@mui/joy/Stack';
import ObjectRelationshipCard from '@components/objects/ObjectRelationshipCard';
import { gradientTint } from "@utils/gradientTint";
import { getAbbreviatedDay } from "@utils/strings";
import { getHoursForDay } from "@api/businessService";

interface BaseColumn {
  label: string;
  class?: string;
}

interface ColumnWithValue extends BaseColumn {
  // label: string;
  value: string;//|number|null;
  // class?: string;
  transformer?: never;
} //& CommonColumn

interface ColumnWithTransformer extends BaseColumn {
  // label: string;
  value?: never;
  // class?: string;
  transformer: Function;
}

type IColumn = ColumnWithValue | ColumnWithTransformer;

const ObjectRelationshipHours = memo(function ObjectRelationshipHours({
  relationship = [],
  title,
  tint = null,
  sort = null,
  columns,
  collapsible = true,
}) {
  const isEmpty = !relationship;

  return (
    <ObjectRelationshipCard
      unpadded
      empty={isEmpty}
      title={
        <CardOverflow
          sx={theme => ({
            borderTopLeftRadius: 'calc(var(--Card-childRadius) + var(--variant-borderWidth))',
            borderTopRightRadius: 'calc(var(--Card-childRadius) + var(--variant-borderWidth))',
            marginBlockStart: 'var(--CardOverflow-offset)',
            ...gradientTint(theme, tint),
          })}
        >
          <CardActions
            sx={theme => ({
              py: 1.5,
            })}
          >
            <Stack
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              spacing={0.5}
            >
              <Typography sx={theme => ({flex: 1, fontWeight: '600', color: 'white' })}>{title}</Typography>
            </Stack>
          </CardActions>
        </CardOverflow>
      }
    >
      {relationship.length === 0 && (
        <CardContent sx={{ px: 2, py: 1.5 }}>
          <Typography fontSize={'sm'}>This business does not have any listed hours.</Typography>
        </CardContent>
      )}
      {/* <CardOverflow> */}
      <Table
        // stickyHeader
        stripe="odd"
        // hoverRow
        sx={{
          margin: 0,
          padding: 0,
          tableLayout: 'auto',
          'tbody th': {
            backgroundColor: 'transparent',
          },
          /*
          'tbody td': {
            borderWidth: '0 !important',
          },
          */
        }}
      >
        <tbody>
        {relationship.map((row, rowIndex:number) => (
          <tr key={rowIndex}>
            {/* <th scope="row" className="min">{getAbbreviatedDay(row.day)}</th> */}
            <th scope="row" className="min">{row.day}</th>
            <td>{getHoursForDay(row)}</td>
          </tr>
        ))}
        </tbody>
      </Table>
      {/* </CardOverflow> */}

    </ObjectRelationshipCard>
  );
});

export default ObjectRelationshipHours;
